import { useState } from "react";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { ReactSVG } from "react-svg";
import { LoaderCircle } from "@/components/Global/LoaderCircle/LoaderCircle";
import { useRating } from "@/context/RatingContext"; // Pfad anpassen
import styles from "./RecipeStarsVoting.module.scss";

export const RecipeStarsVoting = () => {
  const { getLabel, getIcon } = useGlobalContext();
  const { handleVote, setIsVoting, isLoading } = useRating();
  const emptyStars = 5;
  const starFilledIcon = getIcon("starfilled");
  const starEmptyIcon = getIcon("starEmpty");
  const [starIcon, setStarIcon] = useState(new Array(5).fill(starEmptyIcon));
  function handleHover(index: number) {
    setStarIcon(
      starIcon.map((star, i) => {
        return (star = index >= i ? starFilledIcon : starEmptyIcon);
      }),
    );
  }

  return (
    <div className={`${styles["recipe-stars-voting"]}`}>
      <div className="is-flex is-justify-content-space-between">
        <div className={`${styles.stars}`}>
          {[...Array(emptyStars)].map((star, i) => (
            <button
              key={"Empty Star " + i}
              onMouseEnter={() => handleHover(i)}
              onMouseLeave={() => setStarIcon(new Array(5).fill(starEmptyIcon))}
              onClick={() => handleVote(i)}
              className="button-reset"
              aria-label={getLabel("aria_label_recipe_rate").replace(
                "$$number",
                `${i + 1}`,
              )}
            >
              <ReactSVG
                className={styles.star}
                src={starIcon[i]}
                width={24}
                height={24}
                beforeInjection={(svg) => {
                  svg.setAttribute("width", "24");
                  svg.setAttribute("height", "24");
                  svg.setAttribute("aria-hidden", "true");
                }}
                wrapper="svg"
              />
            </button>
          ))}
          {isLoading && <LoaderCircle />}
        </div>
        <button
          aria-label={getLabel("vote_close")}
          onClick={() => setIsVoting(false)}
          style={{ cursor: "pointer" }}
          className="button-reset"
        >
          <ReactSVG
            src={getIcon("close")}
            width={24}
            height={24}
            wrapper="svg"
            beforeInjection={(svg) => {
              svg.setAttribute("width", "24");
              svg.setAttribute("height", "24");
              svg.setAttribute("aria-hidden", "true");
            }}
            aria-hidden
          />
        </button>
      </div>
      <p>{getLabel("vote_now")}</p>
    </div>
  );
};

export default RecipeStarsVoting;
